var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScroll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_361",
    "data-name": "Group 361",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.295,
    height: 51.734,
    viewBox: "0 0 26.295 51.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M26.295,12.856A12.857,12.857,0,0,0,13.438,0h-.582A12.857,12.857,0,0,0,0,12.856V23.783A12.856,12.856,0,0,0,12.856,36.639h.582A12.857,12.857,0,0,0,26.295,23.783ZM24.139,23.783a10.7,10.7,0,0,1-10.7,10.7h-.582a10.7,10.7,0,0,1-10.7-10.7V12.856a10.7,10.7,0,0,1,10.7-10.7h.582a10.7,10.7,0,0,1,10.7,10.7Z",
    fill: "#787cfe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M17.313,14.59a1.078,1.078,0,0,0-1.078,1.078v3.161a1.078,1.078,0,0,0,2.156,0V15.668a1.078,1.078,0,0,0-1.078-1.078",
    transform: "translate(-4.183 -3.759)",
    fill: "#787cfe"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M14.793,67.207a1.078,1.078,0,0,0,1.347,0l5.388-4.31a1.077,1.077,0,1,0-1.346-1.683l-4.716,3.771-4.715-3.772A1.077,1.077,0,0,0,9.406,62.9Z",
    transform: "translate(-2.319 -15.709)",
    fill: "#787cfe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.6b79105dd0a3b124bd2e51b0398182ba.svg";
export { ForwardRef as ReactComponent };